export default __webpack_public_path__ + "static/media/dashboardPayNestLogo.5207b989.svg";